<div class="modal-content">
  <div class="modal-header bg-success text-white">
    <h4 class="modal-title">
      <i class="fas fa-robot mr-2"></i>
      <b>AI ile Blog Yaz</b>
    </h4>
    <button type="button" class="close text-white" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form [formGroup]="form">
    <div class="modal-body">

      <div class="row">
        <!-- Prompt Seçimi -->
        <div class="col-md-6">
          <div class="form-group">
            <label>Prompt <span class="text-danger">*</span></label>
            <select class="form-control" formControlName="promptId"
              [class.is-invalid]="form.get('promptId').invalid && form.get('promptId').touched">
              <option value="">Prompt Seçin</option>
              <option *ngFor="let p of prompts" [value]="p.id">{{ p.name }}</option>
            </select>
            <div class="invalid-feedback">Prompt seçimi zorunludur.</div>
          </div>
        </div>

        <!-- Dil Seçimi -->
        <div class="col-md-6">
          <div class="form-group">
            <label>Dil <span class="text-danger">*</span></label>
            <select class="form-control" formControlName="languageId"
              [class.is-invalid]="form.get('languageId').invalid && form.get('languageId').touched">
              <option value="">Dil Seçin</option>
              <option *ngFor="let lang of languages" [value]="lang.id">{{ lang.name }}</option>
            </select>
            <div class="invalid-feedback">Dil seçimi zorunludur.</div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Kategori -->
        <div class="col-md-6">
          <div class="form-group">
            <label>Kategori <span class="text-danger">*</span></label>
            <select class="form-control" formControlName="blogCategoryId"
              [class.is-invalid]="form.get('blogCategoryId').invalid && form.get('blogCategoryId').touched">
              <option value="">Kategori Seçin</option>
              <option *ngFor="let cat of categories" [value]="cat.id">{{ cat.name }}</option>
            </select>
            <div class="invalid-feedback">Kategori seçimi zorunludur.</div>
          </div>
        </div>

        <!-- Hedef Kitle -->
        <div class="col-md-6">
          <div class="form-group">
            <label>Hedef Kitle <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="targetAudience"
              placeholder="Örn: Dil öğrenen yetişkinler, A2 seviyesi"
              [class.is-invalid]="form.get('targetAudience').invalid && form.get('targetAudience').touched">
            <div class="invalid-feedback">Hedef kitle zorunludur.</div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Konu -->
        <div class="col-md-12">
          <div class="form-group">
            <label>Konu <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="topic"
              placeholder="Örn: İngilizce öğrenmenin 5 kolay yolu"
              [class.is-invalid]="form.get('topic').invalid && form.get('topic').touched">
            <div class="invalid-feedback">Konu zorunludur.</div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Anahtar Kelimeler -->
        <div class="col-md-12">
          <div class="form-group">
            <label>Anahtar Kelimeler <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="keywords"
              placeholder="Örn: İngilizce öğren, dil kursu, online İngilizce"
              [class.is-invalid]="form.get('keywords').invalid && form.get('keywords').touched">
            <small class="text-muted">Virgülle ayırın</small>
            <div class="invalid-feedback">Anahtar kelimeler zorunludur.</div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- OpenAI API Key -->
        <div class="col-md-12">
          <div class="form-group">
            <label>OpenAI API Key <span class="text-danger">*</span></label>
            <input type="password" class="form-control" formControlName="openAiApiKey"
              placeholder="sk-..."
              [class.is-invalid]="form.get('openAiApiKey').invalid && form.get('openAiApiKey').touched">
            <small class="text-muted">API anahtarınız yalnızca bu istek için kullanılır.</small>
            <div class="invalid-feedback">API key zorunludur.</div>
          </div>
        </div>
      </div>

      <div *ngIf="generating" class="alert alert-info d-flex align-items-center mt-2">
        <i class="fas fa-spinner fa-spin mr-2"></i>
        Blog yazısı oluşturuluyor, lütfen bekleyin...
      </div>

    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="generating">Kapat</button>
      <button type="button" class="btn btn-success" (click)="generate()" [disabled]="generating">
        <i class="fas fa-robot mr-1"></i>
        {{ generating ? 'Oluşturuluyor...' : 'AI ile Oluştur ve Kaydet' }}
      </button>
    </div>
  </form>
</div>
